export default "__VITE_ASSET__CzmqYxOS__"